module.exports = __webpack_public_path__ + "pound-coin.46258e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/coins/pound-coin.png
// module id = 557
// module chunks = 0